import { Routes } from '@angular/router';

import { authGuard, guestGuard } from './core/auth/auth.guards';

export const routes: Routes = [
  // Pages publiques de retour Wave (WAVE_CHECKOUT_SUCCESS_URL / WAVE_CHECKOUT_ERROR_URL).
  {
    path: 'paiement/succes',
    title: 'Paiement reçu - Bara Chap Chap',
    loadComponent: () => import('./features/payment-return/payment-success.page').then((m) => m.PaymentSuccessPage),
  },
  {
    path: 'paiement/erreur',
    title: 'Paiement non abouti - Bara Chap Chap',
    loadComponent: () => import('./features/payment-return/payment-error.page').then((m) => m.PaymentErrorPage),
  },
  // Page publique : URL de la politique de confidentialité pour les stores.
  {
    path: 'politique-de-confidentialite',
    title: 'Politique de confidentialité - Bara Chap Chap',
    loadComponent: () => import('./features/legal/privacy-policy.page').then((m) => m.PrivacyPolicyPage),
  },
  // Page publique : conditions générales d'utilisation (lien des stores et des apps).
  {
    path: 'conditions-utilisation',
    title: "Conditions d'utilisation - Bara Chap Chap",
    loadComponent: () => import('./features/legal/terms-of-use.page').then((m) => m.TermsOfUsePage),
  },
  {
    path: 'connexion',
    title: 'Connexion - Administration',
    canMatch: [guestGuard],
    loadComponent: () => import('./features/auth/login.page').then((m) => m.LoginPage),
  },
  {
    path: '',
    canMatch: [authGuard],
    loadComponent: () => import('./layout/shell').then((m) => m.Shell),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'tableau-de-bord' },
      {
        path: 'tableau-de-bord',
        title: 'Tableau de bord',
        loadComponent: () => import('./features/dashboard/dashboard.page').then((m) => m.DashboardPage),
      },
      {
        path: 'clients',
        title: 'Clients',
        loadComponent: () => import('./features/customers/customers.page').then((m) => m.CustomersPage),
      },
      {
        path: 'clients/:id',
        title: 'Fiche client',
        loadComponent: () => import('./features/customers/customer-detail.page').then((m) => m.CustomerDetailPage),
      },
      {
        path: 'artisans',
        title: 'Artisans',
        loadComponent: () => import('./features/pros/pros.page').then((m) => m.ProsPage),
      },
      {
        path: 'artisans/:id',
        title: 'Fiche artisan',
        loadComponent: () => import('./features/pros/pro-detail.page').then((m) => m.ProDetailPage),
      },
      {
        path: 'catalogue',
        title: 'Catégories et communes',
        loadComponent: () => import('./features/catalog/catalog.page').then((m) => m.CatalogPage),
      },
      {
        path: 'reservations',
        title: 'Réservations',
        loadComponent: () => import('./features/bookings/bookings.page').then((m) => m.BookingsPage),
      },
      {
        path: 'reservations/:id',
        title: 'Détail réservation',
        loadComponent: () => import('./features/bookings/booking-detail.page').then((m) => m.BookingDetailPage),
      },
      {
        path: 'paiements',
        title: 'Paiements',
        loadComponent: () => import('./features/payments/payments.page').then((m) => m.PaymentsPage),
      },
      {
        path: 'suppressions-compte',
        title: 'Suppressions de compte',
        loadComponent: () =>
          import('./features/account-deletions/account-deletions.page').then((m) => m.AccountDeletionsPage),
      },
      {
        path: 'evaluations',
        title: 'Évaluations',
        loadComponent: () => import('./features/reviews/reviews.page').then((m) => m.ReviewsPage),
      },
      {
        path: 'notifications',
        title: 'Notifications',
        loadComponent: () => import('./features/notifications/notifications.page').then((m) => m.NotificationsPage),
      },
      {
        path: 'journal',
        title: "Journal d'audit",
        loadComponent: () => import('./features/audit/audit.page').then((m) => m.AuditPage),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
